module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "personal-center-form__section"
  }, [_c('h1', {
    staticClass: "loan_detail_h1 loan_detail_two_line"
  }, [_c('span', [_vm._v("Apply Time: " + _vm._s(_vm.loanAllData.applyDate))])]), _vm._v(" "), (_vm.loanAllData.itemApplyId) ? _c('h1', {
    staticClass: "loan_detail_h1 loan_detail_two_line"
  }, [_c('span', [_vm._v("Loan#: " + _vm._s(_vm.loanAllData.itemApplyId))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "loan_detail_first"
  }, [_c('ul', {
    staticClass: "text-center"
  }, [_c('li', [_c('em', [_vm._v("Loan Amount")]), _vm._v(" "), _c('strong', [_vm._v("$" + _vm._s(_vm.loanAllData.loanAmount))])]), _vm._v(" "), _c('li', [_c('em', [_vm._v("Status")]), _vm._v(" "), _c('strong', [_vm._v("\n              " + _vm._s(_vm.loanAllData.auditState) + "\n              "), _c('img', {
    attrs: {
      "src": require("../../../static/images/loan_state.png"),
      "alt": "Loan Status"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "mobile-hide-button"
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAgreement
    }
  }, [_vm._v("View Contract")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "loan_detail_second"
  }, [_c('ul', [_c('li', [_c('span', [_vm._v("Loan Start Date")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.loanAllData.loanSdate))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Term of Loan")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.loanAllData.loanExpires))])]), _vm._v(" "), (Number(_vm.userInfo.crmCustomerType) === 2) ? _c('li', [_c('span', [_vm._v("Business license number")]), _vm._v(" "), _c('strong', {
    attrs: {
      "title": _vm.loanAllData.enterpriseNumber
    }
  }, [_vm._v(_vm._s(_vm.loanAllData.enterpriseNumber))])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Maturity Date")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.loanAllData.loanEdate))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Repayment method")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.loanAllData.repayType))])])])]), _vm._v(" "), _c('div', {
    staticClass: "loan_detail_three"
  }, [_vm._m(0), _vm._v(" "), _c('el-table', {
    staticClass: "table-body pointer",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.loanAllData.repayInfoList
    },
    on: {
      "row-click": _vm.roRepaymentInfo
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "period",
      "label": "Term",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "item_index"
        }, [_vm._v(_vm._s(scope.row.period))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "repayDate",
      "label": "Scheduled Repayment Date",
      "width": "125"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Principal",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("$" + _vm._s(_vm._f("addThousandSign")(scope.row.repayPrincipal, 2)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Interest",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("$" + _vm._s(_vm._f("addThousandSign")(scope.row.repayInterest, 2)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Scheduled Total",
      "width": "137"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("$" + _vm._s(_vm._f("addThousandSign")(scope.row.repaySum, 2)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Unpaid amount",
      "width": "128"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#35C4F9"
          }
        }, [_vm._v("$" + _vm._s(_vm._f("addThousandSign")(scope.row.balancedSum, 2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "status",
      "prop": "repayStatus"
    }
  })], 1), _vm._v(" "), (_vm.loanAllData.repayInfoList.length > 0) ? _c('el-pagination', {
    staticClass: "pament-list-pagination",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "small": _vm.isSmall,
      "layout": "prev, pager, next",
      "page-count": _vm.loanAllData.pageCount,
      "page-size": _vm.pageSize,
      "current-page": _vm.pageCurrent
    },
    on: {
      "current-change": _vm.changePage
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "showManagerDialog",
    attrs: {
      "title": "Manager info",
      "visible": _vm.showManagerDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showManagerDialog = $event
      }
    }
  }, [_c('dl', [_c('dd', [_c('div', {
    staticClass: "name_title"
  }, [_vm._v("name")]), _vm._v(" "), _c('div', {
    staticClass: "name_text"
  }, [_vm._v(_vm._s(_vm.loanAllData.managerFullName))]), _vm._v(" "), _c('div', {
    staticClass: "name_title"
  }, [_vm._v("phone")]), _vm._v(" "), _c('div', {
    staticClass: "name_text"
  }, [_vm._v(_vm._s(_vm.loanAllData.managerMobile))]), _vm._v(" "), _c('div', {
    staticClass: "name_title"
  }, [_vm._v("email")]), _vm._v(" "), _c('div', {
    staticClass: "name_text"
  }, [_vm._v(_vm._s(_vm.loanAllData.managerEmail))])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "contract dialog",
    attrs: {
      "top": "5%",
      "title": "contract",
      "visible": _vm.showAgreementDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showAgreementDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "contract__dialog-body agreement_contract"
  }, [_c('img', {
    attrs: {
      "src": _vm.readContract,
      "alt": "read"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog__footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.signBtn.isShow) ? _c('el-button', {
    staticClass: "dialog__footer__confirm-btn sign_btn",
    staticStyle: {
      "margin-right": "30px"
    },
    attrs: {
      "disabled": _vm.signBtn.state
    },
    on: {
      "click": _vm.showSignAgreement
    }
  }, [_vm._v(_vm._s(_vm.signBtn.text))]) : _vm._e(), _vm._v(" "), (!_vm.signBtn.isShow) ? _c('el-button', {
    staticClass: "dialog__footer__confirm-btn sign_btn",
    staticStyle: {
      "margin-right": "30px"
    },
    attrs: {
      "disabled": _vm.signBtn.state
    },
    on: {
      "click": _vm.downAgreement2
    }
  }, [_vm._v("Download Contract")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "showSignDialog",
    attrs: {
      "top": "5%",
      "title": "Checking Account Information",
      "visible": _vm.showCheckDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showCheckDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "stepForm",
    attrs: {
      "label-width": '30%',
      "model": _vm.stepForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Routing Number"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "",
      "maxlength": 30
    },
    model: {
      value: (_vm.stepForm.routingNumber),
      callback: function($$v) {
        _vm.$set(_vm.stepForm, "routingNumber", $$v)
      },
      expression: "stepForm.routingNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account Number"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "",
      "maxlength": 30
    },
    model: {
      value: (_vm.stepForm.accountNumber),
      callback: function($$v) {
        _vm.$set(_vm.stepForm, "accountNumber", $$v)
      },
      expression: "stepForm.accountNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog__footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "dialog__footer__confirm-btn sign_btn",
    staticStyle: {
      "margin-right": "30px"
    },
    on: {
      "click": _vm.submitCheckDialog
    }
  }, [_vm._v("NEXT")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "contract dialog",
    attrs: {
      "top": "5%",
      "title": "Check Pictures",
      "visible": _vm.uploadDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.uploadDialog = $event
      }
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avata avatar-uploader-icon",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.imageUrl) ? _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon",
    staticStyle: {
      "background": "url(/static/images/checkFront.jpg)",
      "background-size": "100% 100%"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Front Side")])]) : _vm._e()]), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-uploader",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess2,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [(_vm.imageUrl2) ? _c('img', {
    staticClass: "avatar avatar-uploader-icon",
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "src": _vm.imageUrl2
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.imageUrl2) ? _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon",
    staticStyle: {
      "background": "url(/static/images/checkBack.jpg)",
      "background-size": "100% 100%"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Back Side")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dialog__footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "dialog__footer__confirm-btn sign_btn",
    staticStyle: {
      "margin-right": "30px"
    },
    on: {
      "click": _vm.submitUploadDialog
    }
  }, [_vm._v("NEXT")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "showSignDialog",
    attrs: {
      "title": "Confirm the signing of the contract",
      "visible": _vm.showSignDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showSignDialog = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Sign by inputing your name",
      "auto-complete": "off"
    },
    on: {
      "change": _vm.allowSubmit
    },
    model: {
      value: (_vm.fullName),
      callback: function($$v) {
        _vm.fullName = $$v
      },
      expression: "fullName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "tel",
      "pattern": _vm.patternValue,
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Your 9 digital only Social Security Number",
      "auto-complete": "off",
      "maxlength": 9,
      "minlength": 9,
      "required": ""
    },
    on: {
      "change": _vm.allowSubmit
    },
    model: {
      value: (_vm.ssn),
      callback: function($$v) {
        _vm.ssn = $$v
      },
      expression: "ssn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "SMSVerificationCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "VALID CODE",
      "disabled": _vm.isAllowSendingVerifyCode,
      "maxlength": 6
    },
    on: {
      "change": _vm.allowSubmit
    },
    model: {
      value: (_vm.SMSVerificationCode),
      callback: function($$v) {
        _vm.SMSVerificationCode = $$v
      },
      expression: "SMSVerificationCode"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "user-operation__sms-button",
    staticStyle: {
      "margin-right": "5px",
      "margin-top": "2px"
    },
    attrs: {
      "type": "primary",
      "size": "mini",
      "loading": _vm.isLoading,
      "disabled": _vm.SMSVerificationCodeBtn.disabled
    },
    on: {
      "click": _vm.getSMSVerificationCode
    }
  }, [_vm._v(_vm._s(_vm.SMSVerificationCodeBtn.text))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showSignDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.allowSubmitBut
    },
    on: {
      "click": _vm.signAgreement
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-title"
  }, [_vm._v("\n          Repayment Schedule\n          "), _vm._v(" "), _c('div', {
    staticClass: "tips_info el-icon-information"
  }, [_vm._v("Enterprise users only support offline repaymentï¼�")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e40b07a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/LoanDetail.vue
// module id = 1993
// module chunks = 5